module.exports = __webpack_public_path__ + "img/distributor-content-p2-content-img2.71b36a2e.png";